module.exports = __webpack_public_path__ + "static/media/fr.f85e9b61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/fr.svg
// module id = 116
// module chunks = 0